import { NgModule } from 'ng-metadata/core';
import { SummaryItemComponent } from './summary-item.component';
import './summary-item.scss';

@NgModule({
  declarations: [SummaryItemComponent],
})
export class SummaryItemModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/summary/summary-item/summary-item.module.ts